import { Component, AfterViewInit, ElementRef, ContentChild, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RenameModalComponent } from './rename-modal/rename-modal.component';
import { PreferencesService } from '../../api/services/preferences.service';
import { UserService } from '../../api/services/user.service';
import { AuthService } from '../../api/services/auth.service';

@Component({
  selector: 'app-renamable',
  templateUrl: './renamable.component.html',
  styleUrls: ['./renamable.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RenamableComponent implements AfterViewInit {

  @Input() key: string;

  constructor(private modalService: NgbModal,
              private preferencesService: PreferencesService,
              private userService: UserService,
              private authService: AuthService
            ) { }

  @ContentChild('element') element: ElementRef;

  customName: string;
  defaultName: string;

  getProjectName() {
    this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
      this.preferencesService.getPreferences('CUSTOMER', user['Organization ID']).subscribe(prefs => {

        this.customName = prefs['label-project-name-original'].Value;
        this.defaultName = prefs['label-project-name-original']['Default Value'];
        this.element.nativeElement.innerText = this.customName === ''? this.defaultName : this.customName;

      });
    });
  }

  openModal() {
    const modalRef = this.modalService.open(RenameModalComponent, {
      size: 'lg',
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.customName = this.customName;
    modalRef.componentInstance.defaultName = this.defaultName;
    modalRef.componentInstance.key = this.key;

    modalRef.result.then( () => {
      this.getProjectName();
    })
    .catch(() => {});
  }

  ngAfterViewInit() {
    this.getProjectName();
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/renamable/renamable.component.ts